import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { apiClient } from '@/lib/apiClient'
import { API_ROUTES } from '@/constants/apiRoutes'
import { CertGroupList, CertGroup } from '@/types/index'

// Fetch list of cert_id/cert_name pairs from API
export const getCardGroupList = createAsyncThunk<CertGroup[]>(API_ROUTES.ADMIN_CARD_GROUP_LIST_ENDPOINT, async () => {
    const res = await apiClient.get(API_ROUTES.ADMIN_CARD_GROUP_LIST_ENDPOINT)
    const data = (res as any).data ? (res as any).data : res

    if (Array.isArray(data)) {
        return data.map((item: any) => ({
            cert_id: item.cert_id ?? '',
            cert_name: item.cert_name ?? '',
        }))
    }

    return []
})

const initialState: CertGroupList = {
    card_groups: [],
    loading: false,
    error: null,
}

const adminCardGroupSlice = createSlice({
    name: 'adminCardGroup',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // GET CARD GROUP LIST
            .addCase(getCardGroupList.pending, (state) => {
                state.loading = true
                state.error = null
            })
            .addCase(getCardGroupList.fulfilled, (state, action) => {
                // action.payload is CardGroup[]
                state.card_groups = action.payload
                state.loading = false
            })
            .addCase(getCardGroupList.rejected, (state, action) => {
                state.error = action.error.message || 'Error'
                state.loading = false
            })
    },
})

export default adminCardGroupSlice.reducer
